import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloseQuote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCloseQuote2"><Path d="M2 4V13.7857H5.5V20.3459C6.10893 20.1094 6.68953 19.9105 7.25254 19.5825C7.66787 19.3405 8.21967 18.9655 8.77247 18.4287C9.88719 17.3463 11 15.608 11 13.0357V4H2Z" fill="currentColor"/><Path d="M13 4V13.7857H16.5V20.3459C17.1089 20.1094 17.6895 19.9105 18.2525 19.5825C18.6679 19.3405 19.2197 18.9655 19.7725 18.4287C20.8872 17.3463 22 15.608 22 13.0357V4H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloseQuote2;
